import React from 'react';

const Page8RatingBasedCommunication = ({ 
  communicationRatings,
  updateCommunicationRating,
  handlePrevious,
  handleNext 
}) => {
  return (
    <>
      <div className="questions-grid">
        <div className="question-item full-width">
          <label>On a scale of 0-10, how satisfied are you with the responsiveness of Cloudphysician's care center for ICU?</label>
          <div className="nps-scores">
            {[...Array(11)].map((_, index) => (
              <button
                key={index}
                className={`score-button ${communicationRatings.icu === index ? 'selected' : ''}`}
                onClick={() => updateCommunicationRating('icu', index)}
              >
                {index}
              </button>
            ))}
          </div>
          <p className="rating-description">
            0 = Not at all satisfied, 10 = Extremely satisfied
          </p>
        </div>
        
        <div className="question-item full-width">
          <label>On a scale of 0-10, how satisfied are you with the responsiveness of Cloudphysician's customer support team (CST)?</label>
          <div className="nps-scores">
            {[...Array(11)].map((_, index) => (
              <button
                key={index}
                className={`score-button ${communicationRatings.cst === index ? 'selected' : ''}`}
                onClick={() => updateCommunicationRating('cst', index)}
              >
                {index}
              </button>
            ))}
          </div>
          <p className="rating-description">
            0 = Not at all satisfied, 10 = Extremely satisfied
          </p>
        </div>
      </div>
      <div className="button-group">
        <button className="nav-button" onClick={handlePrevious}>Previous</button>
        <button 
          className="nav-button" 
          onClick={handleNext}
          disabled={communicationRatings.icu === null || communicationRatings.cst === null}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default Page8RatingBasedCommunication;
